<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <m-datatable
        :headers="headers"
        :apiUrl="url"
        :filters.sync="filters"
        @dblclick:row="(e, row) => $router.push(to(row.item))"
        ref="datatable"
      >
        <template #item.settle="{ item }">
          <v-btn color="light-blue white--text" :to="toSettle(item)" text>تسویه</v-btn>
        </template>
        <template #item.detail="{ item }">
          <detail-link :to="to(item)" />
        </template>
      </m-datatable>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TransactionsList",
  props: {
    type: {},
  },
  data() {
    return {
      filters: {},
      url: "reports/lists/transactions",
    };
  },
  computed: {
    title() {
      switch (this.type) {
        case "receive":
          return "لیست دریافت ها";
        case "payment":
          return "لیست پرداخت ها";
        case "imprest":
          return "صورت حساب کلی تنخواه";
      }
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "نام حساب",
          value: "account.name",
        },
        {
          text: "تاریخ",
          value: "date",
        },
        {
          text: "شرح",
          value: "explanation",
        },
      ];

      let imprestHeaders = [
        {
          text: "مبلغ پرداختی",
          value: "sanad.bed",
          type: "numeric",
        },
        {
          text: "تاریخ تسویه",
          value: "imprestSettlement.date",
        },
        {
          text: "مبلغ تسویه شده",
          value: "imprestSettlement.settled_value",
          type: "numeric",
        },
        {
          text: "مانده",
          value: "remain",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "تسویه",
          value: "settle",
          sortable: false,
          filterable: false,
        },
      ];

      if (this.type == "imprest") {
        headers = headers.concat(imprestHeaders);
      } else {
        headers = headers.concat([
          {
            text: "مبلغ مجموع",
            value: "sanad.bed",
            type: "numeric",
          },
        ]);
      }

      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });
      return headers;
    },
  },
  created() {
    this.filters.type = this.type;
  },
  watch: {
    $route() {
      this.$refs.datatable.getDataFromApi();
    },
  },
  methods: {
    to(item) {
      return {
        name: "TransactionForm",
        params: {
          type: this.type,
          id: item.id,
        },
      };
    },

    toSettle(item) {
      return {
        name: "ImprestSettlement",
        params: {
          id: item.id,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
